import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "src/app/services/global.service";
import * as SecureLS from "secure-ls";
import { StorageService } from "src/app/services/storage.service";

@Component({
  selector: "app-error-modal",
  templateUrl: "./error-modal.component.html",
  styleUrls: ["./error-modal.component.css"],
})
export class ErrorModalComponent implements OnInit {
  @Input() id;
  @Input() errMsg;
  private ls = new SecureLS({ encodingType: "aes" });
  page_size: number = 7;
  page: number = 1;
  total_count: any;
  errorData: any = 0;

  constructor(
    public globalService: GlobalService,
    public activeModal: NgbActiveModal,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.getErrorMsgDetails();
  }

  private getErrorMsgDetails() {
    this.globalService
      .get("classVideoDetail/get-device-errorlog", {
        user_id: this.ls.get("createdBy"),
        role_id: this.storageService.getRole(),
        vendor_id: this.ls.get("vendor_id"),
        classroom_video_details_id: this.id,
        page_size: this.page_size,
        page: this.page,
      })
      .then((data: any) => {
        this.errorData = data;
        this.total_count = data?.content?.count;
      });
  }

  getPage(page: number) {
    this.page = page;
    this.getErrorMsgDetails();
  }
}
